import { gql } from "@apollo/client";

const FORGOT_PASSWORD_SEND = gql`
mutation ForgotPasswordMutation($email: String!) {
  forgotPassword(email: $email)
}
`;

export default FORGOT_PASSWORD_SEND;